import { CanMatchFn } from '@angular/router';
import { AuthConfigService, AuthFacade, AuthProvider } from '@rx-applications/shared/auth/data-access';
import { map } from 'rxjs';
import { inject } from '@angular/core';

export function mfaGuard(): CanMatchFn {
  return () =>
    inject(AuthConfigService).config?.authProvider === AuthProvider.Cognito &&
    inject(AuthFacade).sessionId$.pipe(map((sessionId) => !!sessionId));
}
